// Centralized API endpoints to match Azure Functions routes
// Production base URL is injected via config/api client; use only relative paths here

const endpoints = {
  auth: {
    login: '/api/auth/login',
    register: '/api/auth/register',
    me: '/api/auth/me',
    users: (id) => (id ? `/api/auth/users/${id}` : '/api/auth/users'),
  },
  queries: {
    ask: '/api/queries/ask',
    suggestions: '/api/queries/suggestions',
    filters: '/api/queries/filters',
  },
  documents: {
    list: '/api/documents',
    stats: '/api/documents/stats/overview',
    remove: (id) => `/api/documents/${id}`,
  },
  upload: {
    document: '/api/upload/document',
    url: '/api/upload/url',
    email: '/api/upload/email',
    youtube: '/api/upload/youtube',
  },
  feedback: {
    submit: '/api/feedback',
    list: '/api/feedback',
    approved: '/api/feedback/approved',
    update: (id) => `/api/feedback/${id}`,
    updateStatus: (id) => `/api/feedback/${id}/status`,
    delete: (id) => `/api/feedback/${id}`,
  },
  conversations: {
    create: '/api/conversations',
    list: '/api/conversations',
    get: (id) => `/api/conversations/${id}`,
    delete: (id) => `/api/conversations/${id}`,
    softDelete: (id) => `/api/conversations/${id}/soft`,
    addMessage: (id) => `/api/conversations/${id}/messages`,
    stats: '/api/conversations/stats/overview',
    cleanup: '/api/conversations/cleanup',
  },
};

export default endpoints;
